import { render, staticRenderFns } from "./Archipelago.vue?vue&type=template&id=e5030736"
import script from "./Archipelago.vue?vue&type=script&lang=js"
export * from "./Archipelago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports